import styled from "styled-components";
import { bodyTextBold, bodyTextRegular, linkActionColor } from "./style";
import { breakpoint } from "./style";
export const StyledExpandableSection = styled.section`

    ${bodyTextRegular}

    margin: 50px 0px;
    padding: 0px 100px;
    min-height: 80vh;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:first-of-type {
        padding-top: 0px;
    }

    & p {
        font-size: 16pt;
        line-height: 30pt;
        font-weight: 400;
        padding: 20px 0px;
        background-color: rgba(255,255,255, 0.9);
    }

    & h3 {
        ${bodyTextBold}
        font-size: 24pt;

    }

    @media ${breakpoint.phone} {

        margin: 20px 0px;
        padding: 0px 40px;
        & p {
            font-size: 14pt;
            line-height: 22pt;
        
        }

    }


`;

const ReadMoreButton = styled.div`
    font-size: 16pt;
    text-align: right;
    color: ${linkActionColor};
    cursor: pointer;
    font-weight: 700;
    background-color: rgba(255,255,255,0.9);

    &:hover {
        text-shadow: 2px 2px 3px #e0e0e0;
    }

    @media ${breakpoint.phone} {

            font-size: 14pt;
            line-height: 22pt;
        

    }

`;

const ExpandableSection = ({handleReadMore, children}) => {


    return <StyledExpandableSection>
        {children}
        <ReadMoreButton onClick={() => handleReadMore()} >Keep reading &rarr;</ReadMoreButton>

    </StyledExpandableSection>;
}

export default ExpandableSection;